// import { Link } from "react-router-dom";
// import { ADDRESS, EMAIL, HEAD_OFFICE, PHONE } from "../constants";
// import { FaInstagram, FaLinkedin, FaGoogle, FaFacebook } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer className="bg-[#1D3557] text-gray-300 py-12 px-6">
//       <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
//         {/* Logo and Tagline */}
//         <div>
//           <h2 className="text-2xl font-bold text-white mb-2">
//             Kubermax
//           </h2>
//           <p className="text-sm">
//             Kubermax is a fast and secure short-term loan platform
//             exclusively for salaried individuals. Get instant approvals, minimal
//             documentation, and 100% digital disbursals directly to your bank
//             account.
//           </p>
//           <h3 className="text-lg font-semibold text-white mb-3">Follow Us</h3>
//           <div className="flex space-x-4 text-xl">
//             <Link
//               to="https://www.instagram.com/kubermax/?igsh=MXVzM3llNGFwOXozaw%3D%3D#"
//               target="_blank"
//               className="hover:text-[#FFD700] transition"
//             >
//               <FaInstagram />
//             </Link>
//             <Link
//               to="https://www.linkedin.com/company/kubermax/"
//               target="_blank"
//               className="hover:text-[#FFD700] transition"
//             >
//               <FaLinkedin />
//             </Link>
//             <Link
//               to="https://www.facebook.com/people/Paisa-On-Salary/pfbid0S8G6GLzp76PBBzpPZDruvu5gMe3k4UwuJZvy5EVssijCR4oxV7VR6EoofdecD8kdl/?mibextid=wwXIfr&rdid=mpNCeIAcoy93rQrS&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F19oyV7ydTK%2F%3Fmibextid%3DwwXIfr"
//               target="_blank"
//               className="hover:text-[#FFD700] transition"
//             >
//               <FaFacebook />
//             </Link>
//             <Link
//               to="https://www.kubermax.com/"
//               target="_blank"
//               className="hover:text-[#FFD700] transition"
//             >
//               <FaGoogle />
//             </Link>
//           </div>
//         </div>

//         {/* Social Media */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-3">Policies</h3>
//           <ul className="space-y-2">
//             <li>
//               <Link
//                 to="/corporate-governance"
//                 className="hover:text-[#FFD700] transition"
//               >
//                 Corporate Governance
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/fair-practice-code"
//                 className="hover:text-[#FFD700] transition"
//               >
//                 Fair Practice Code
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/risk-management"
//                 className="hover:text-[#FFD700] transition"
//               >
//                 Risk Management
//               </Link>
//             </li>
//             <li>
//               <Link to="/interest-rate" className="hover:text-[#FFD700] transition">
//                 Interest Rate
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* Quick Links */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-3">Quick Links</h3>
//           <ul className="space-y-2">
//             <li>
//               <Link to="/" className="hover:text-[#FFD700] transition">
//                 Home
//               </Link>
//             </li>
//             <li>
//               <Link to="/about-us" className="hover:text-[#FFD700] transition">
//                 About Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/contact" className="hover:text-[#FFD700] transition">
//                 Contact Us
//               </Link>
//             </li>
//             <li>
//               <Link to="/privacypolicy" className="hover:text-[#FFD700] transition">
//                 Privacy Policy
//               </Link>
//             </li>
//             <li>
//               <Link
//                 to="/termsandconditions"
//                 className="hover:text-[#FFD700] transition"
//               >
//                 Terms and Conditions
//               </Link>
//             </li>
//           </ul>
//         </div>

//         {/* Contact Info */}
//         <div>
//           <h3 className="text-lg font-semibold text-white mb-3">
//             Connect With Us
//           </h3>
//           <ul className="space-y-2 text-sm">
//             <li>
//               <p>Branch Address:</p>
//               <p>📍 {ADDRESS}</p>
//             </li>
//             <li>📧 {EMAIL}</li>
//             <li>📞 {PHONE}</li>
//           </ul>
//         </div>
//       </div>

//       <div className="text-center mt-10 text-sm text-gray-500">
//         © {new Date().getFullYear()} Kubermax, powered by Kubermarg foundation. All rights reserved.
//       </div>
//     </footer>
//   );
// };

// export default Footer;
import { Link } from "react-router-dom";
import { ADDRESS, EMAIL, PHONE, NBFC_NAME, NBFC_COR, NBFC_CIN } from "../constants";
import { FaInstagram, FaLinkedin, FaGoogle, FaFacebook } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="relative bg-[#050A18] text-gray-300 py-16 px-6 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1020] via-[#0B1326] to-[#050A18] opacity-80"></div>
      <div className="absolute top-[-120px] left-[-80px] w-[350px] h-[350px] bg-[#4FA0FF]/15 blur-[150px] rounded-full"></div>
      <div className="absolute bottom-[-120px] right-[-80px] w-[350px] h-[350px] bg-[#1D4ED8]/15 blur-[150px] rounded-full"></div>

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        {/* LOGO + SOCIALS */}
        <div className="space-y-4">
          <h2 className="text-3xl font-extrabold text-white tracking-wide">
            Kubermax
          </h2>

          <p className="text-sm text-white/70 leading-relaxed">
           India’s fastest short-term financial support platform — designed for salaried
individuals. Instant approval • Minimal documentation • 100% Digital process.
          </p>

          <h3 className="text-lg font-semibold text-white mt-5">Follow Us</h3>

          <div className="flex space-x-3">
            {[
              {
                Icon: FaInstagram,
                link: "https://www.instagram.com/kubermax/?igsh=MXVzM3llNGFwOXozaw%3D%3D#",
              },
              {
                Icon: FaLinkedin,
                link: "https://www.linkedin.com/company/kubermax/",
              },
              // {
              //   Icon: FaFacebook,
              //   link: "https://www.facebook.com/people/Paisa-On-Salary/pfbid0S8G6GLzp76PBBzpPZDruvu5gMe3k4UwuJZvy5EVssijCR4oxV7VR6EoofdecD8kdl/",
              // },
              { Icon: FaGoogle, link: "https://www.kubermax.com/" },
            ].map(({ Icon, link }, i) => (
              <Link
                key={i}
                to={link}
                target="_blank"
                className="w-10 h-10 flex items-center justify-center 
                rounded-full bg-white/10 backdrop-blur-xl 
                hover:bg-white/20 hover:shadow-[0_0_15px_#4FA0FF]
                transition text-white"
              >
                <Icon />
              </Link>
            ))}
          </div>
        </div>

        {/* Policies */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Policies</h3>
          <ul className="space-y-2 text-white/75">
            {[
              { name: "Corporate Governance", url: "/corporate-governance" },
              { name: "Fair Practice Code", url: "/fair-practice-code" },
              // { name: "Risk Management", url: "/risk-management" },
              { name: "Regulatory Compliance", url: "/regulatory" },
              { name: "Interest Rate", url: "/interest-rate" },
               { name: "Refund Policy", url: "/refund-policy" },
            ].map((item, i) => (
              <li key={i}>
                <Link to={item.url} className="hover:text-[#4FA0FF] transition">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">Quick Links</h3>
          <ul className="space-y-2 text-white/75">
            {[
              { name: "Home", url: "/" },
              { name: "About Us", url: "/about-us" },
              { name: "Contact Us", url: "/contact" },
              { name: "Privacy Policy", url: "/privacypolicy" },
              { name: "Terms & Conditions", url: "/termsandconditions" },
            ].map((item, i) => (
              <li key={i}>
                <Link to={item.url} className="hover:text-[#4FA0FF] transition">
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-semibold text-white mb-3">
            Connect With Us
          </h3>

          <ul className="space-y-3 text-white/75 text-sm leading-relaxed">
            <li>📍 Branch: {ADDRESS}</li>
            <li>📧 Email: {EMAIL}</li>
            <li>📞 Phone: {PHONE}</li>
          </ul>
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center mt-10 text-sm text-white/60">
        © {new Date().getFullYear()} Kubermax — powered by {NBFC_NAME}.
        All rights reserved.
        <p className="mt-1 text-xs">
          RBI Registered NBFC &middot; CoR No. {NBFC_COR} &middot; CIN: {NBFC_CIN}
        </p>
      </div>
    </footer>
  );
};

export default Footer;